import React from 'react'
import {ListGroupItem} from 'reactstrap'
import styled from 'styled-components'
import cn from 'classnames'

const Styles = styled.div`
  .item-option-label {
    &:hover {
      transition: background-color 200ms linear;
      background: var(--light);
    }
  }
`

const ListItemOption = (props) => {
  const {active, onClick, children} = props

  return (
    <Styles>
      <ListGroupItem
        onClick={onClick}
        className={cn([
          'p-0',
          'h-100',
          'w-100',
          'd-flex',
          'align-self-center',
          'justify-content-between',
        ])}
        style={{cursor: 'pointer'}}
      >
        <div
          className={cn([
            active ? 'bg-primary' : 'bg-light',
            "d-flex",
            "px-2"
          ])}
        >
          <i
            className={cn([
              "fa-dot-circle text-white",
              "p-2 align-self-center fa"
            ])}
          />
        </div>
        <div className="item-option-label w-100 px-3 py-3 d-flex justify-content-between align-self-center">
          {children}
        </div>
      </ListGroupItem>
    </Styles>
  )
}

export default ListItemOption
